import type { EntityData } from "../types/entity";

export function createDefaultEntityData(sessionId: string): EntityData {
  return {
    id: "",
    form_session_id: sessionId,
    cui: "",
    nume_entitate: "",
    tip_entitate: null,
    adresa: "",
    telefon: "",
    email: "",
    website: "",
    tip_organizatie: null,
    nr_salariati: 0,
    cifra_afaceri: 0,
    dimensiune: null,
    active: 0,
    entity_size: null,
    caen_principal: {
      cod: "",
      denumire: "",
    },
    caen_secundar: [],
    created_at: "",
    updated_at: "",
    anaf_raw_data: {
      date_generale: {
        act: "",
        cui: 0,
        fax: "",
        data: "",
        iban: "",
        adresa: "",
        telefon: "",
        cod_CAEN: "",
        denumire: "",
        nrRegCom: "",
        codPostal: "",
        forma_juridica: "",
        forma_organizare: "",
        data_inregistrare: "",
        stare_inregistrare: "",
        statusRO_e_Factura: false,
        forma_de_proprietate: "",
        organFiscalCompetent: "",
        data_inreg_Reg_RO_e_Factura: "",
      },
      stare_inactiv: {
        dataRadiere: "",
        dataPublicare: "",
        dataInactivare: "",
        dataReactivare: "",
        statusInactivi: false,
      },
      inregistrare_RTVAI: {
        tipActTvaInc: "",
        dataInceputTvaInc: "",
        dataSfarsitTvaInc: "",
        statusTvaIncasare: false,
        dataPublicareTvaInc: "",
        dataActualizareTvaInc: "",
      },
      adresa_sediu_social: {
        stara: "",
        scod_Judet: "",
        scod_Postal: "",
        snumar_Strada: "",
        scod_JudetAuto: "",
        scod_Localitate: "",
        sdenumire_Judet: "",
        sdetalii_Adresa: "",
        sdenumire_Strada: "",
        sdenumire_Localitate: "",
      },
      inregistrare_SplitTVA: {
        statusSplitTVA: false,
        dataAnulareSplitTVA: "",
        dataInceputSplitTVA: "",
      },
      inregistrare_scop_Tva: {
        scpTVA: false,
        perioade_TVA: [],
      },
      adresa_domiciliu_fiscal: {
        dtara: "",
        dcod_Judet: "",
        dcod_Postal: "",
        dnumar_Strada: "",
        dcod_JudetAuto: "",
        dcod_Localitate: "",
        ddenumire_Judet: "",
        ddetalii_Adresa: "",
        ddenumire_Strada: "",
        ddenumire_Localitate: "",
      },
    },
    anaf_data_fetched_at: "",
    anaf_last_updated: "",
    data_source: "",
    infocui_raw_data: null,
    infocui_data_fetched_at: null,
    financial_data_year: null,
    surse_date: null,
    has_vat_registration: false,
    anaf_vat_validated: false,
    anaf_vat_validated_at: "",
    original_cui_input: "",
    clean_cui: "",
    cif: "",
    original_cifra_afaceri_ron: 0,
    original_active_ron: 0,
    currency_conversion_rate: 0,
    currency_converted_at: "",
    selected_services: null,
    nis_classification: null,
    contact_data: null,
    impact_analysis: null,
    relatie_stat_roman: null,
    situatie_servicii_ue: null,
    documente_anexate: null,
  };
}
